
import React from "react";
import { FaPhoneAlt, FaThumbsUp, FaThumbsDown, FaRegMeh } from "react-icons/fa";

const EmployerDashboard = () => {
  return (
    <div className="flex-1 bg-[#f9fafb] p-6 relative min-h-screen">
      {/* Top-right Profile Card */}
      <div className="absolute right-6 top-6 bg-white border border-gray-200 shadow-sm p-4 rounded-lg w-64 text-sm">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 rounded-full bg-[#004349] flex items-center justify-center text-white font-bold">
            S
          </div>
          <div>
            <p className="font-medium text-gray-800">S Graham</p>
            <p className="text-gray-500">Plan: <span className="font-medium text-gray-700">Standard</span></p>
          </div>
        </div>
        <p className="text-gray-600">Available job slots: <strong>0 of 0</strong></p>
        <button className="text-blue-600 text-sm mt-1 hover:underline">Manage</button>
      </div>

      {/* Header */}
      <h1 className="text-2xl font-semibold text-gray-800 mb-6">Dashboard</h1>

      {/* Candidates Section */}
      <div className="bg-white border border-gray-200 rounded-lg p-5 mb-6">
        <h2 className="text-lg font-semibold text-gray-800 mb-1">Rate Latest Candidates</h2>
        <p className="text-sm text-gray-600 mb-4">
          View the candidates who most recently applied to your job. Rate your candidates to help us find more matches.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          <div className="bg-gray-50  border rounded p-4">
            <div className="h-14 bg-gray-200 rounded mb-2"></div>
            <div className="h-3 bg-gray-200 rounded mb-1"></div>
            <div className="h-3 bg-gray-200 rounded w-3/4 mb-3"></div>
            <div className="flex justify-between text-xl text-gray-400">
              <FaThumbsUp className="cursor-pointer hover:text-green-600" />
              <FaRegMeh className="cursor-pointer hover:text-yellow-600" />
              <FaThumbsDown className="cursor-pointer hover:text-red-600" />
            </div>
          </div>

          {/* Help Card */}
          <div className="flex items-center justify-center border rounded p-6 bg-white">
            <div className="text-center text-gray-700">
              <div className="mx-auto mb-3 w-14 h-14 bg-black/10 text-black rounded-full flex items-center justify-center text-2xl">
                ?
              </div>
              <h3 className="font-semibold mb-1">Need Help?</h3>
              <p className="text-sm text-gray-600 mb-1">
                Hiring Specialists are a FREE resource to get you more candidates. Contact one today!
              </p>
              <div className="text-sm font-medium text-[#004349] flex items-center justify-center gap-2 mt-2">
                <FaPhoneAlt />
                (877) 252-1062
              </div>
            </div>
          </div>
        </div>

        <div className="text-right mt-3">
          <button className="text-blue-600 text-sm hover:underline">View All</button>
        </div>
      </div>

      {/* Discover Section */}
      <div className="mb-6">
        <h3 className="text-md font-semibold text-gray-800 mb-3">Discover</h3>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {[
            {
              title: "TrafficBoost",
              text: "Get up to 10X more candidates.",
              btn: "Learn More",
            },
            {
              title: "Activate your Account",
              text: "Enable job posting now.",
              btn: "Activate",
            },
            {
              title: "Questions?",
              text: "Contact your Hiring Specialist.",
              btn: "Contact Now",
            },
            {
              title: "Learn More",
              text: "Learn how ZipRecruiter works.",
              btn: "Watch Now",
            },
          ].map((card, idx) => (
            <div key={idx} className="bg-white border rounded-lg p-5 text-center">
              <div className="mb-2 h-12 w-12 mx-auto bg-gray-100 rounded-full"></div>
              <h4 className="font-semibold text-gray-800 mb-1">{card.title}</h4>
              <p className="text-sm text-gray-600 mb-2">{card.text}</p>
              <button className="text-blue-600 text-sm hover:underline">{card.btn}</button>
            </div>
          ))}
        </div>
      </div>

      {/* Account Activity Section */}
      <div className="bg-white border rounded-lg p-5">
        <h2 className="text-md font-semibold text-gray-800 mb-4">Account Activity</h2>
        <div className="grid grid-cols-2 md:grid-cols-6 text-center text-sm text-gray-700 gap-4">
          <div>
            <p className="text-xl font-bold">0</p>
            <p>Jobs posted</p>
          </div>
          <div>
            <p className="text-xl font-bold">0</p>
            <p>Job views</p>
          </div>
          <div>
            <p className="text-xl font-bold">0</p>
            <p>Candidates received</p>
            <button className="text-blue-600 text-sm hover:underline">View</button>
          </div>
          <div>
            <p className="text-xl font-bold">0</p>
            <p>TrafficBoost credits</p>
            <button className="text-blue-600 text-sm hover:underline">Get more</button>
          </div>
          <div>
            <p className="text-xl font-bold">$0.00</p>
            <p>Available credit</p>
            <button className="text-blue-600 text-sm hover:underline">Get more</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployerDashboard;

